import React, { useEffect } from 'react';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { ProblemBlock } from './components/ProblemBlock';
import { SocialProofBar } from './components/SocialProofBar';
import { BenefitsSection } from './components/BenefitsSection';
import { HowItWorks } from './components/HowItWorks';
import { ProductIntro } from './components/ProductIntro';
import { WorkbooksSection } from './components/WorkbooksSection';
import { BonusesSection } from './components/BonusesSection';
import { VisualApproachSection } from './components/VisualApproachSection';
import { ValueStack } from './components/ValueStack';
import { AudienceSection } from './components/AudienceSection';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { ClosingBlock } from './components/ClosingBlock';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { FloatingCTA } from './components/FloatingCTA';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  useEffect(() => {
    document.title = 'CHIMIE VISUELLE™ | Bibliothèque de ressources de chimie prêtes à l’emploi';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'CHIMIE VISUELLE™ est une bibliothèque pédagogique très visuelle pour les professeurs de physique-chimie : 5 volumes pédagogiques et 4 ressources complémentaires, soit 460 pages de schémas, fiches, activités, évaluations et corrigés prêts à imprimer ou à projeter. Paiement unique de 19 €, accès numérique immédiat et accès à vie.');
  }, []);
  return <div className="w-full bg-paper text-ink" data-id="element-0" data-mp="35ozexlizgwa">
      <MetaPixel data-id="element-1" data-mp="38kwkjpju1jo" />
      <StickyHeader data-id="element-2" data-mp="3uct43lu76r1j" />
      <main data-id="element-3" data-mp="3uday0bte0t6a">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-4" data-mp="3udkqq75thefo" />
        <Hero data-id="element-5" data-mp="3uf5hdlp0gd89" />
        <ProblemBlock data-id="element-6" data-mp="d4e6dvbvvgxr" />
        <SocialProofBar data-id="element-7" data-mp="d4xpvgh6mddw" />
        <BenefitsSection data-id="element-8" data-mp="d45sq17xs7li" />
        <HowItWorks data-id="element-9" data-mp="d2biphy7dzw7" />
        <ProductIntro data-id="element-10" data-mp="85uk1ttdo34v" />
        <WorkbooksSection data-id="element-11" data-mp="85b8cuubmaza" />
        <BonusesSection data-id="element-12" data-mp="864d5q9pyqes" />
        <VisualApproachSection data-id="element-13" data-mp="83qi3hf1he78" />
        <ValueStack data-id="element-14" data-mp="3gkuxpirvf992" />
        <AudienceSection data-id="element-15" data-mp="3gm63tp8sgt3c" />
        <Testimonials data-id="element-16" data-mp="3gja6a20us6ff" />
        <Guarantee data-id="element-17" data-mp="3bmbfntgeehlz" />
        <ClosingBlock data-id="element-18" data-mp="3bmtgz4hx3m0r" />
        <FAQ data-id="element-19" data-mp="3bnmgbkejr98v" />
        <Footer data-id="element-20" data-mp="3bnurn7v0u6hy" />
        <div className="h-[54px] md:hidden" aria-hidden="true" data-id="element-21" data-mp="3bk72ekwm0691" />
        <SocialProofPopup data-id="element-22" data-mp="3qbzgyuokxg9p" />
        <FloatingCTA data-id="element-23" data-mp="3qdaienujybxn" />
      </main>
    </div>;
}